var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { TPAComponentsConsumer } from '../TPAComponentsConfig';
import { Tag as CoreTag, TagsList as CoreTagList, } from 'wix-ui-core/dist/es/src/components/tags-list';
import { st, classes } from './Tags.st.css';
import classnames from 'classnames';
import { TAGS_DATA_KEYS } from './dataHooks';
import { TagsAlignment, TagsSize, TagsSkin, } from './types';
/** A Selector Component */
var Tags = /** @class */ (function (_super) {
    __extends(Tags, _super);
    function Tags() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Tags.prototype.getTagDataAttributes = function (_a) {
        var _b;
        var isChecked = _a.isChecked, index = _a.index;
        return _b = {},
            _b[TAGS_DATA_KEYS.tagIsChecked] = isChecked,
            _b[TAGS_DATA_KEYS.index] = index,
            _b;
    };
    Tags.prototype.getTagsListDataAttributes = function (_a) {
        var _b;
        var alignment = _a.alignment, skin = _a.skin, size = _a.size, rtl = _a.rtl;
        return _b = {},
            _b[TAGS_DATA_KEYS.alignment] = alignment,
            _b[TAGS_DATA_KEYS.skin] = skin,
            _b[TAGS_DATA_KEYS.size] = size,
            _b[TAGS_DATA_KEYS.rtl] = rtl,
            _b;
    };
    Tags.prototype.generateTagItems = function () {
        var _this = this;
        var _a = this.props, items = _a.items, onClick = _a.onClick;
        return items.map(function (item, index) {
            var _a;
            return (React.createElement(CoreTag, __assign({ key: item.value, checked: item.checked, onChange: function () { return onClick(item); }, disabled: item.disabled, link: item.link, rel: item.rel, value: item.value, className: classnames(classes.tag, (_a = {}, _a[classes.checked] = item.checked, _a)) }, _this.getTagDataAttributes({
                isChecked: item.checked,
                index: index,
            })), item.title));
        });
    };
    Tags.prototype.render = function () {
        var _this = this;
        var _a = this.props, alignment = _a.alignment, size = _a.size, skin = _a.skin, className = _a.className;
        return (React.createElement(TPAComponentsConsumer, null, function (_a) {
            var rtl = _a.rtl;
            return (React.createElement(CoreTagList, __assign({ "data-hook": _this.props['data-hook'] }, _this.getTagsListDataAttributes({
                alignment: alignment,
                skin: skin,
                size: size,
                rtl: rtl,
            }), { className: st(classes.root, {
                    alignment: alignment,
                    skin: skin,
                    size: size,
                    rtl: rtl,
                }, className) }), _this.generateTagItems()));
        }));
    };
    Tags.displayName = 'Tags';
    Tags.defaultProps = {
        alignment: TagsAlignment.center,
        size: TagsSize.medium,
        skin: TagsSkin.solid,
    };
    return Tags;
}(React.Component));
export { Tags };
//# sourceMappingURL=Tags.js.map